{
  "dataSync": {
    "sync": {
      "title": {
        "loading": "Abgleich",
        "personio": "Abgleich mit Personio",
        "excel": "Abgleich mit Excel"
      },
      "steps": {
        "structure": "Struktur",
        "newPeople": "Neue Personen",
        "changes": "Änderungen",
        "leavers": "Abgänge",
        "removals": "Entfernen",
        "confirm": "Bestätigen"
      },
      "stepsLabel": "Schritte",
      "kind": {
        "departmentCreate": "Neue Abteilung",
        "departmentMove": "Abteilung verschoben",
        "teamCreate": "Neues Team",
        "roleCreate": "Neue Funktion",
        "systemCreate": "Neues System",
        "unitRename": {
          "department": "Abteilung umbenannt",
          "team": "Team umbenannt",
          "role": "Funktion umbenannt",
          "system": "System umbenannt"
        },
        "unitLead": {
          "department": "Abteilungsleitung",
          "team": "Teamleitung",
          "role": "Funktionsleitung",
          "system": "Systemverantwortlicher"
        },
        "unitDelete": {
          "department": "Abteilung löschen",
          "team": "Team löschen",
          "role": "Funktion löschen",
          "system": "System löschen"
        }
      },
      "labelled": "{{label}}: {{value}}",
      "under": "unter {{name}}",
      "topLevel": "Oberste Ebene",
      "field": {
        "name": "Name",
        "email": "E-Mail",
        "department": "Abteilung",
        "role": "Stelle",
        "team": "Team",
        "location": "Standort"
      },
      "skipped": {
        "missingEmail": "Ohne E-Mail"
      },
      "unsuppliedPeople_one": "{{count}} Person aus {{source}} kann nicht übernommen werden, weil Abteilung, Stelle oder E-Mail fehlen:",
      "unsuppliedPeople_other": "{{count}} Personen aus {{source}} können nicht übernommen werden, weil Abteilung, Stelle oder E-Mail fehlen:",
      "blockedReason": {
        "missingDepartment": "Ohne Abteilung",
        "missingRole": "Ohne Stelle",
        "missingOwner": "Ohne Systemverantwortlichen",
        "nameTaken": "Name bereits vergeben",
        "emailNotChangeable": "Diese E-Mail kann hier nicht geändert werden",
        "emailTaken": "E-Mail bereits vergeben",
        "externalPerson": "Externe Person",
        "actingAdmin": "Dein eigenes Konto",
        "lastOrgManager": "Letzter Organisationsmanager",
        "inUse": "Wird noch verwendet",
        "personioLed": "Von Personio geführt"
      },
      "waitingOn": "Erst wählbar, wenn die zugehörigen Zeilen gewählt sind: {{steps}}",
      "leaverReason": {
        "inactive": "inaktiv in Personio",
        "absentPersonio": "nicht mehr in Personio",
        "absentExcel": "nicht mehr in der Datei"
      },
      "holds": {
        "leads": "Leitet {{name}}",
        "processesOwned_one": "Eigentümer von {{count}} Prozess",
        "processesOwned_other": "Eigentümer von {{count}} Prozessen",
        "processesAccountable_one": "Verantwortlich für {{count}} Prozess",
        "processesAccountable_other": "Verantwortlich für {{count}} Prozesse",
        "systemOwned": "Systemverantwortlich {{name}}",
        "openAssignments_one": "{{count}} offene Aufgabe",
        "openAssignments_other": "{{count}} offene Aufgaben"
      },
      "usage": {
        "people_one": "{{count}} Person",
        "people_other": "{{count}} Personen",
        "subDepartments_one": "{{count}} Unterabteilung",
        "subDepartments_other": "{{count}} Unterabteilungen",
        "orgFunctions_one": "{{count}} Team oder Funktion",
        "orgFunctions_other": "{{count}} Teams oder Funktionen",
        "processes_one": "{{count}} Prozess",
        "processes_other": "{{count}} Prozesse",
        "processSteps_one": "{{count}} Prozessschritt",
        "processSteps_other": "{{count}} Prozessschritte",
        "suggestions_one": "{{count}} Vorschlag",
        "suggestions_other": "{{count}} Vorschläge"
      },
      "confirm": {
        "structure": "Struktur anlegen oder ändern",
        "createPeople": "Personen anlegen",
        "changePeople": "Personen ändern",
        "deletePeople": "Personen löschen",
        "deleteUnits": "Abteilungen, Teams, Funktionen und Systeme löschen",
        "deleteNamedUnits": "{{units}} löschen",
        "changeNamedLeads": "Leitung von {{units}} ändern",
        "noDownloadList": "Diese Datei stammt nicht aus „{{button}}“. Bliks schlägt deshalb keine Abgänge und kein Entfernen vor."
      },
      "unitCount": {
        "department_one": "{{count}} Abteilung",
        "department_other": "{{count}} Abteilungen",
        "team_one": "{{count}} Team",
        "team_other": "{{count}} Teams",
        "role_one": "{{count}} Funktion",
        "role_other": "{{count}} Funktionen",
        "system_one": "{{count}} System",
        "system_other": "{{count}} Systeme"
      },
      "apply": "Abgleich anwenden",
      "applied": "Abgleich angewendet",
      "notApplied": "Nicht angewendet",
      "outcome": {
        "failed": "Fehlgeschlagen",
        "conflict": "Der Wert wurde seit der Prüfung in Bliks geändert"
      },
      "retry": "Erneut anwenden"
    },
    "settings": {
      "title": "Datenabgleich",
      "kind": {
        "excel": "Excel",
        "personio": "Personio"
      },
      "connections": "Verbindungen",
      "connected": "Verbunden",
      "connect": "Verbinden",
      "uploadExcel": "Excel hochladen",
      "downloadExcel": "Excel herunterladen",
      "startSync": "Abgleich starten",
      "changeCredentials": "Zugangsdaten ändern",
      "continueSync": "Abgleich fortsetzen",
      "unlink": "Trennen",
      "unlinkConfirm": {
        "title": "Personio trennen?",
        "description": "In Bliks wird nichts gelöscht. Personen, Abteilungen und Teams aus Personio pflegst du danach in Bliks oder per Excel."
      },
      "lastSync": "Letzter Abgleich: {{date}}",
      "noSyncApplied": "Noch kein Abgleich angewendet",
      "invalidRow": "Blatt {{sheet}}, Zeile {{row}}: {{errors}}",
      "emptyFile": "Das Blatt {{sheet}} enthält keine Personen.",
      "sheetRows_one": "Blatt {{sheet}}, Zeile {{rows}}",
      "sheetRows_other": "Blatt {{sheet}}, Zeilen {{rows}}",
      "missingSheets": "Der Datei fehlen Blätter ({{sheets}}). Bitte die aktuelle Datei herunterladen und die Änderungen dort eintragen.",
      "missingColumns": "Einigen Blättern fehlen Spalten. Bitte die aktuelle Datei herunterladen und die Änderungen dort eintragen.",
      "sheetColumns": "Blatt {{sheet}}: {{columns}}"
    },
    "personio": {
      "title": "Personio verbinden",
      "replaceTitle": "Zugangsdaten ändern",
      "clientId": "Client-ID",
      "clientSecret": "Client-Secret",
      "test": "Verbindung testen",
      "testSucceeded": "Die Verbindung funktioniert.",
      "connect": "Verbinden",
      "instructions": {
        "step1": "In Personio unter <bold>Einstellungen → API-Zugriffsdaten</bold> auf „Individuelle Integration erstellen“ klicken (nur mit einem Personio-Tarif mit API-Zugriff).",
        "step2": "Leseberechtigung für <bold>Mitarbeitende</bold> aktivieren (damit liest Bliks auch die Anstellungen für die Stelle) und unter <bold>Lesbare Mitarbeitendenattribute</bold> diese Attribute freigeben: ID, First name, Last name, Email, Status, Department, Team, Position, Supervisor, Workplace. Ohne ID, Status, Email, Department und Position kann Bliks niemanden übernehmen.",
        "step3": "Leseberechtigung für <bold>Organisationseinheiten</bold> aktivieren (Abteilungen, Teams und deren Leitungen).",
        "step3a": "Für die Stelle: Leseberechtigung für den <bold>Job catalog</bold> aktivieren.",
        "step4": "<bold>Individuelle Berichte</bold> ausgeschaltet lassen.",
        "step5": "Client-ID und Client-Secret hier eintragen und auf „Verbindung testen“ klicken.",
        "readOnlyNote": "Bliks liest nur diese Felder und schreibt nie etwas in Personio.",
        "helpLink": "Personio-Hilfe: API-Zugriffsdaten",
        "helpUrl": "https://support.personio.de/hc/de/articles/4404623630993-API-Anmeldedaten-generieren-und-verwalten"
      }
    }
  }
}
